import { render, staticRenderFns } from "./shipperManagement.vue?vue&type=template&id=1bcc00e4&scoped=true"
import script from "./shipperManagement.vue?vue&type=script&lang=js"
export * from "./shipperManagement.vue?vue&type=script&lang=js"
import style0 from "./shipperManagement.vue?vue&type=style&index=0&id=1bcc00e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_1f634a4a4b1fea536ed4e950e01c2669/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bcc00e4",
  null
  
)

export default component.exports